import { RouteConfig } from 'vue-router'

const Map = () => import('../../views/assignment/Map.vue')
const Exam = () => import('../../views/assignment/Exam.vue')
const Paper = () => import('../../views/assignment/Paper.vue')
const Other = () => import('../../views/assignment/Other.vue')
const ExamPaper = () => import('../../views/assignment/ExamPaper.vue')
const ExamResult = () => import('../../views/assignment/ExamResult.vue')
const PaperResult = () => import('../../views/assignment/PaperResult.vue')
const ClazzRankList = () => import('../../views/assignment/ClazzRankList.vue')
const InterdisciplinaryPractice = () => import('../../views/assignment/InterdisciplinaryPractice.vue')
const InterdisciplinaryPracticeEdit = () => import('../../views/assignment/InterdisciplinaryPracticeEdit.vue')

export const mapRoute: RouteConfig = {
  path: '/assignment/map',
  name: 'assignment_map',
  component: Map,
  props: (route) => ({
    ...route.query,
    ...route.params,
    clazzId: route.query.id,
    assigementId: route.query.challenge_arrangement_id,
  }),
  meta: {
    title: '任务地图',
  },
}

export const examRoute: RouteConfig = {
  path: '/assignment/exam',
  name: 'assignment_exam',
  component: Exam,
  props: (route) => ({ ...route.query, ...route.params, examId: route.query.exam_id }),
  meta: {
    title: '知识测验',
  },
}

export const paperRoute: RouteConfig = {
  path: '/assignment/paper',
  name: 'assignment_paper',
  component: Paper,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识问答',
  },
}

export const otherRoute: RouteConfig = {
  path: '/assignment/other',
  name: 'assignment_other',
  component: Other,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跨学科实践',
  },
}

export const examPaperRoute: RouteConfig = {
  path: '/assignment/exam-paper',
  name: 'assignment_exam_paper',
  component: ExamPaper,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识测验',
  },
}

export const examResultRoute: RouteConfig = {
  path: '/assignment/exam-result',
  name: 'assignment_exam_result',
  component: ExamResult,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识测验结果',
  },
}

export const paperResultRoute: RouteConfig = {
  path: '/assignment/paper-result',
  name: 'assignment_paper_result',
  component: PaperResult,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识问答',
  },
}

export const clazzRankListRoute: RouteConfig = {
  path: '/assignment/clazz-rank-list',
  name: 'assignment_clazz_rank_list',
  component: ClazzRankList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '排行榜',
  },
}

export const interdisciplinaryPracticeRoute: RouteConfig = {
  path: '/assignment/interdisciplinary-practice',
  name: 'assignment_interdisciplinary_practice',
  component: InterdisciplinaryPractice,
  props: (route) => ({ ...route.query, ...route.params, clazzId: route.query.id }),
  meta: {
    title: '跨学科实践',
  },
}

export const interdisciplinaryPracticeEditRoute: RouteConfig = {
  path: '/assignment/interdisciplinary-practice-edit',
  name: 'assignment_interdisciplinary_practice_edit',
  component: InterdisciplinaryPracticeEdit,
  props: (route) => ({ ...route.query, ...route.params, clazzId: route.query.id }),
  meta: {
    title: '添加实践记录',
  },
}

export default [
  mapRoute,
  examRoute,
  paperRoute,
  otherRoute,
  examPaperRoute,
  examResultRoute,
  paperResultRoute,
  clazzRankListRoute,
  interdisciplinaryPracticeRoute,
  interdisciplinaryPracticeEditRoute,
]
